import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteGroup } from '../../services/GroupsService';
import { Group, DeleteGroupRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, DeleteGroupRequest>;

function useDeleteGroup(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteGroup, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['groups'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteGroup;
